import { EmptyView, emptyViewVariants } from '@components'

import { useModal } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'

import { ModalId } from '../../../../enums/modalId'
import { Scope } from '../../../../enums/scope'
import { isAuthorized } from '../../../../utils/isAuthorized'

export const ProductsListEmpty = (): ReactElement => {
  const { open } = useModal(ModalId.ProductEditorModal)

  const shouldSeeCreateButton = isAuthorized(Scope.ProductWrite)

  const { animation, description, title, buttonText } = emptyViewVariants.externalProducts

  const handleCreateProductButtonClick = useCallback(() => {
    open()
  }, [open])

  return (
    <EmptyView
      animationName={animation}
      onClick={handleCreateProductButtonClick}
      showCTA={shouldSeeCreateButton}
      tButton={buttonText}
      tDescription={description}
      tTitle={title}
    />
  )
}
